import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetAPICommand, GetListAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class GetPatientLatestPrescriptionMedicine<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, patientId: number) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/prescriptions/latest-medicine-per-patient`,
    );
  }
}
